module.exports = __webpack_public_path__ + "static/FuturaPTBold-f3483f64fe4f53928cfe2786e7ec82cc.otf";